const IMAGE_EXTS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'])
const VIDEO_EXTS = new Set(['mp4', 'webm', 'mov'])
const AUDIO_EXTS = new Set(['mp3', 'wav', 'ogg', 'm4a'])

/**
 * Визначає тип файлу: 'image' | 'video' | 'audio' | 'pdf' | 'unsupported'.
 * Пріоритет: apiType (поле type з бека) → mimeType → розширення файлу.
 */
export function detectFileKind(mimeType, name, apiType) {
    if (apiType) {
        if (apiType === 'image') return 'image'
        if (apiType === 'video') return 'video'
        if (apiType === 'audio') return 'audio'
        if (apiType === 'pdf')   return 'pdf'
    }
    if (mimeType) {
        if (mimeType.startsWith('image/')) return 'image'
        if (mimeType.startsWith('video/')) return 'video'
        if (mimeType.startsWith('audio/')) return 'audio'
        if (mimeType === 'application/pdf') return 'pdf'
        return 'unsupported'
    }
    const ext = String(name || '').split('.').pop().toLowerCase()
    if (IMAGE_EXTS.has(ext)) return 'image'
    if (VIDEO_EXTS.has(ext)) return 'video'
    if (AUDIO_EXTS.has(ext)) return 'audio'
    if (ext === 'pdf') return 'pdf'
    return 'unsupported'
}

/**
 * Витягує дані вкладення з message-об'єкта.
 *
 * Структура бека для type === 'media':
 *   msg.message.link       — URL файлу
 *   msg.message.mime_type  — MIME тип
 *   msg.message.type       — 'image' | 'audio' | 'video' | ...
 *   msg.message.file_name  — ім'я файлу
 *   msg.message.is_file_exist — чи існує файл на сервері
 *
 * Для оптимістичних повідомлень з NewChatComposer msg.message — рядок (ім'я файлу).
 */
export function extractAttachment(message) {
    const raw = message.message

    // Оптимістичне повідомлення: message.message — рядок з назвою файлу
    if (!raw || typeof raw === 'string') {
        return {
            url:         null,
            mimeType:    null,
            name:        typeof raw === 'string' ? raw : '',
            apiType:     null,
            isFileExist: false,
        }
    }

    return {
        url:             raw.link             || null,
        mimeType:        raw.mime_type        || null,
        name:            raw.file_name        || '',
        apiType:         raw.type             || null,
        isFileExist:     raw.is_file_exist    !== false,
        payload:         raw.payload          || null,
        payloadEncoding: raw.payload_encoding || null,
    }
}
